/**
 *
 * StravaAlert
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Button } from 'react-bootstrap';
import { withLeaflet } from 'react-leaflet';
import { ControlAlert } from 'components/AlertList';
import { FormattedMessage } from 'react-intl';

import messages from './messages';

class StravaAlert extends React.PureComponent {
  shouldShow() {
    const { zoom, leaflet, layerControlOpen } = this.props;
    if (zoom < 13) {
      return false;
    }
    if (layerControlOpen) {
      return true;
    }
    let hasStrava = false;
    if (!hasStrava) {
      leaflet.map.eachLayer(layer => {
        // eslint-disable-next-line no-underscore-dangle
        if (hasStrava || (layer._url && layer._url.includes('strava'))) {
          hasStrava = true;
        }
      });
    }
    return hasStrava;
  }

  render() {
    if (!this.shouldShow()) {
      return null;
    }
    const { leaflet } = this.props;
    const zoomOut = () => leaflet.map.setZoom(12);
    return (
      <ControlAlert bsStyle="warning">
        <Button bsStyle="link" className="inline" onClick={zoomOut}>
          <FormattedMessage {...messages.onlyZoomed} />
        </Button>
      </ControlAlert>
    );
  }
}

StravaAlert.propTypes = {
  zoom: PropTypes.number,
  layerControlOpen: PropTypes.bool,
  leaflet: PropTypes.object.isRequired,
};

export default withLeaflet(StravaAlert);
